export const BlogType = {
  READING: 'READING',
  LISTENING: 'LISTENING',
  WRITING: 'WRITING',
  SPEAKING: 'SPEAKING',
  BOOK_REVIEW: 'BOOK_REVIEW',
  CENTER_REVIEW: 'CENTER_REVIEW',
  TEACHER_REVIEW: 'TEACHER_REVIEW',
  COURSE_REVIEW: 'COURSE_REVIEW',
  IELTS_INFO: 'IELTS_INFO',
  GRAMMAR: 'GRAMMAR',
  VOCAB: 'VOCAB',
} as const;
export type BlogType = (typeof BlogType)[keyof typeof BlogType];

export const NEWS_CATEGORY_TYPE_NAME = {
  EVENT: 'Sự kiện',
  ACHIEVEMENT: 'Thành tựu',
  TRAINING: 'Tập huấn',
  TALKSHOW: 'Talkshow',
  COLLABORATION: 'Hợp tác',
};
